// extracted by mini-css-extract-plugin
module.exports = {"card":"OrderHistory_card__3Lj9R","card_content":"OrderHistory_card_content__1Prp-","price":"OrderHistory_price__1yGMY","note":"OrderHistory_note__3Yrar"};